import CalendarSurfaceStore from '../store/schema/CalendarSurfaceStore';
import getCalendarSurfaceStore from '../store/store';
import { CalendarNavigationMode } from 'fabric-calendar';
import { mutatorAction } from 'satcheljs';

/**
 * Mutator to set the navigation mode.
 */
export const setNavigationMode = mutatorAction(
    'setNavigationMode',
    (newMode: CalendarNavigationMode) => {
        const store: CalendarSurfaceStore = getCalendarSurfaceStore();
        store.navigationMode = newMode;
    }
);
